<template>
  <span :class="className">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'TextHeading',
  props: {
    variant: {
      type: String,
      default: 'base',
      validator: function(value) {
        // The value must match one of these strings
        return (
          [
            'sm',
            'md',
            'lg',
            'xl',
            'title',
            'base',
            'section',
            'magazineintro',
            'magazinetitle',
            'subtitle'
          ].indexOf(value) !== -1
        )
      }
    },
    color: {
      type: String,
      default: 'inherit',
      validator: function(value) {
        // The value must match one of these strings
        return (
          [
            'primary',
            'secondary',
            'white',
            'white-light',
            'inherit',
            'base'
          ].indexOf(value) !== -1
        )
      }
    },
    margin: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    wide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return `heading heading--${this.variant} heading--${this.color} ${(this
        .block &&
        'heading--block') ||
        ''} ${(this.wide && 'heading--wide') || ''} ${(this.margin &&
        'heading--margin') ||
        ''}`
    }
  }
}
</script>

<style lang="postcss">
.heading {
  @apply font-sans font-semibold block;
}
/* Variants */
.heading--base {
  @apply text-xl tracking-tight leading-title;
}
.heading--xl {
  @apply text-3xl tracking-tight leading-tight;
}
.heading--lg {
  @apply text-xl tracking-tight leading-tight;
}
.heading--md {
  @apply text-lg;
}
.heading--sm {
  @apply text-xs tracking-wide;
}
.heading--title {
  @apply text-xl tracking-tight leading-tight;
}
.heading--section {
  @apply text-base tracking-tight;
}
.heading--subtitle {
  @apply text-base tracking-wide block mb-2;
}
.heading--magazineintro {
  @apply text-xl tracking-tight leading-tight font-medium;
}
.heading--magazinetitle {
  @apply text-lg tracking-tight leading-tight font-semibold;
}

/* Colors */
.heading--primary {
  @apply text-primary;
}
.heading--secondary {
  @apply text-secondary;
}
.heading--white {
  @apply text-white;
}
.heading--white-light {
  @apply text-white font-normal;
}
.heading--inherit {
  color: inherit;
}

.heading--block {
  @apply block;
}
.heading--margin {
  @apply block mb-4;
}
/* Tracking */
.heading--wide {
  @apply tracking-wide;
}

/* Sizing */
@screen md {
  .heading--subtitle {
    @apply mb-2;
  }
  .heading--xl {
    @apply text-4xl;
  }
  .heading--magazineintro,
  .heading--lg {
    @apply text-3xl;
  }
  .heading--title {
    @apply text-xl;
  }
  .heading--sm {
    @apply text-sm tracking-wide;
  }
  .heading--md {
    @apply text-lg;
  }
  .heading--magazinetitle {
    @apply text-xl;
  }
}

@screen lg {
  .heading--xl {
    @apply text-5xl;
  }
  .heading--magazineintro,
  .heading--lg {
    @apply text-3xl;
  }
  .heading--title {
    @apply text-3xl;
  }
}
</style>
